var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<fieldset><div form-group col-split=\"0\" label=\"{{::$ctrl.emailLabel||'Your Email Address'}}\" placeholder=\"{{::$ctrl.emailPlaceholder||'Please enter the email address associated with your account'}}\" errors=\"$ctrl.bus.validationErrors.Email\" type=\"email\" required=\"true\" autocomplete=\"off\" ng-model=\"$ctrl.request.email\"></div></fieldset>";
var id1="reset-password-fieldset.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;